export default __webpack_public_path__ + "static/media/Galaxy-S20-Ultra.db0ac8e1.png";